import styled from "@emotion/styled";
import { Link } from "@polestar/component-warehouse-react";
import { type FC, type HTMLAttributes, type PropsWithChildren } from "react";

const StyledButton = styled.button`
  background-color: transparent;
  border-width: 0;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  line-height: inherit;
  padding: 0;
`;

type ButtonAttributes = Pick<
  HTMLAttributes<HTMLButtonElement>,
  "onClick" | "className"
>;

type Props = PropsWithChildren<ButtonAttributes>;

const LinkButton: FC<Props> = ({ children, onClick, className }) => {
  return (
    // @ts-expect-error href not needed on a button element
    <Link as={StyledButton} className={className} onClick={onClick}>
      {children}
    </Link>
  );
};

export default LinkButton;
